import React from 'react';
import {t} from '@lingui/core/macro';

import {PasswordResetSent} from 'features/auth';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';

const PasswordResetSentPage: React.FC = () => {
    return (
        <BlankLayout pageTitle={t`Сброс пароля`}>
            <PasswordResetSent/>
        </BlankLayout>
    );
};

export default PasswordResetSentPage;